import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PFieldAbstractComponent } from '../p-field-abstract';

@Component({
    selector: 'p-field-checkbox',
    template: `
        <p-field
            [isMandatory]="isMandatory"
            [label]="label"
            [labelTooltip]="labelTooltip"
            [isReadOnly]="isReadOnly"
            [customClasses]="customClasses"
            [labelOnLeft]="labelOnLeft"
            [shouldTransformLabelTextCase]="shouldTransformLabelTextCase"
        >
            <p-checkbox
                [attr.automation-id]="clickableLabel ? (clickableLabel | toAutomationId: { prefix: 'p-field-checkbox_' }) : ''"
                slot="readMode"
                readonly
                [ngClass]="classes"
                [label]="clickableLabel"
                [checked]="value ?? false"
                [disabled]="isReadOnly"
            ></p-checkbox>

            <p-checkbox
                [attr.automation-id]="clickableLabel ? (clickableLabel | toAutomationId: { prefix: 'p-field-checkbox_' }) : ''"
                [indeterminate]="indeterminate"
                slot="editMode"
                [label]="clickableLabel"
                [ngClass]="classes"
                [checked]="value ?? false"
                (checkedChange)="changeValue($event)"
            ></p-checkbox>
        </p-field>
    `,
    styleUrls: ['./p-field-checkbox.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PFieldCheckboxComponent
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'pFieldCheckbox'
})
export class PFieldCheckboxComponent extends PFieldAbstractComponent<boolean> {
    @Input() label?: string;
    @Input() clickableLabel?: string;
    @Input() isMandatory = false;
    @Input() textCustomClass?: string;
    @Input() isInEditMode = true;
    @Input() customClasses?: string;

    @Input() textInputSize?: string; // TODO: in the legacy site this can get a "L" value to determine using long input width.
    // May implement this or not according to need;
    @Input() placeholder?: string;
    @Input() indeterminate = false;
    @Input() labelOnLeft = true;
    get classes(): object {
        return {
            'p-field-label--checkbox': true,
            textCustomClass: true
        };
    }

    constructor(cd: ChangeDetectorRef) {
        super(cd);
    }

    changeValue(ev: boolean) {
        this.markAsTouched();

        if (!this.isReadOnly) {
            this.value = ev;
            this._onChange(this.value);
        }
    }

    /*
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.isReadOnly) {
            this.control.disable();
        } else {
            this.control.enable();
        }
    }
*/
}
